import { FunctionComponent, useMemo } from 'react';
import { useLocations } from '../../../../../../../hooks/useLocations';

export type LocationLabelProps = {
    locationId: string;
};

export const LocationLabel: FunctionComponent<LocationLabelProps> = ({ locationId }) => {
    const locationIds = useMemo(() => {
        return [locationId];
    }, [locationId]);
    const { data: locations = [] } = useLocations(locationIds, { keepPreviousData: true });

    const location = useMemo(() => {
        return locations[0];
    }, [locations]);

    if (!location) {
        return null;
    }

    return <span>{location.formatted.split('\n').join(', ')}</span>;
};
